import { ChangeDetectionStrategy, Component, ElementRef, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { copyToClipboard } from '@shared/utils';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'answer-code-header',
  templateUrl: './answer-code-header.component.html',
  styleUrls: ['./answer-code-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnswerCodeHeaderComponent implements OnInit {
  lang: WritableSignal<string> = signal(null);
  toggleCopyTooltip: WritableSignal<boolean> = signal(false);

  @ViewChild(Tooltip) tooltip;
  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    const dataLang = this.elementRef.nativeElement.getAttribute('data-code-lang');
    this.lang.set(dataLang);
  }

  async copyHighlightCode() {
    const codeBlock = this.elementRef.nativeElement?.nextElementSibling?.querySelector('code');
    if (codeBlock) {
      const code = codeBlock.innerText;
      await copyToClipboard(code);
      this.toggleCopyTooltip.update((value) => !value);
    }
  }
}
